import { useEffect, useState } from "react";
import axios from "axios";
import { roleLabel } from "../utils/auth";

const API_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_LOCAL_API_URL;

function formatLoginDate(dateString) {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat("sv-SE", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  }).format(date);
}

function LoginLog() {
  const [days, setDays] = useState(1);
  const [logins, setLogins] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    axios.get(`${API_URL}/users/login-log`, {
      headers: {
        "Content-Type": "application/json",
        token: localStorage.getItem("token")
      },
      params: {
        days
      }
    })
      .then((response) => {
        setLogins(response.data.logins || []);
        setErrorMessage("");
      })
      .catch((error) => {
        setErrorMessage(error.response?.data?.message || "Kunde inte hämta inloggningsloggen");
      });
  }, [days]);

  return (
    <div className="flex flex-col items-center px-3">
      <div className="w-full max-w-3xl py-4">
        <div className="rounded-[28px] bg-gradient-to-br from-slate-50 via-white to-sky-50 p-5 shadow-sm ring-1 ring-slate-200/80">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-sky-700">
            Administration
          </p>
          <h1 className="mt-2 text-lg font-bold text-slate-800">
            Inloggningslogg
          </h1>
          <div className="mt-4 flex justify-center">
            <select
              value={days}
              onChange={(e) => setDays(parseInt(e.target.value, 10))}
              className="w-72 rounded-2xl border border-sky-200 bg-white px-5 py-3 text-black shadow-sm outline-none transition-colors focus:border-sky-400"
            >
              <option value={1}>Senaste dagen</option>
              <option value={3}>Senaste 3 dagarna</option>
              <option value={7}>Senaste 7 dagarna</option>
              <option value={14}>Senaste 14 dagarna</option>
            </select>
          </div>

          {errorMessage && (
            <p className="mx-auto mt-4 w-72 rounded-2xl border border-red-300 bg-red-50 px-5 py-2 text-sm">
              {errorMessage}
            </p>
          )}

          {!errorMessage && (
            <div className="mt-5 space-y-3">
              {logins.length === 0 && (
                <div className="rounded-[22px] border border-slate-200 bg-white/80 px-4 py-4 text-sm text-slate-600">
                  Inga inloggningar hittades för vald period.
                </div>
              )}
              {logins.map((login) => (
                <div
                  key={login._id}
                  className="flex flex-col gap-2 rounded-[22px] border border-sky-200/80 bg-gradient-to-r from-white via-sky-50 to-cyan-50 px-4 py-4 shadow-sm sm:flex-row sm:items-center sm:justify-between"
                >
                  <div>
                    <p className="text-base font-semibold text-slate-800">
                      {login.displayName || login.username}
                    </p>
                    <p className="mt-1 text-sm text-slate-600">
                      {roleLabel(login.role)}
                    </p>
                  </div>
                  <p className="text-sm font-medium text-sky-700">
                    {formatLoginDate(login.loginAt)}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default LoginLog;
